import { Text, Stack } from '@backyard-ui/core';

import { type Statistics } from '@/infra/services/catalog/review/model';
import { RatingStars } from '@/presenters/components/common/RatingStars';

interface StarResumeProps extends Pick<Statistics, 'avgRating'> {}

export default function StarResume(props: StarResumeProps) {
  const { avgRating } = props;

  return (
    <Stack direction="column" align={{ initial: 'center', md: 'flex-start' }}>
      <Text color="gray-600">Nota média do produto</Text>

      <Stack align="center" spacing={4}>
        <Text size="6xl" weight="bold" asChild>
          <span>{avgRating}</span>
        </Text>

        <RatingStars rating={Number(avgRating)} />
      </Stack>
    </Stack>
  );
}
